import React from 'react';

export function PbSoundLogo(): JSX.Element {
    return (<img alt="Logo" style={{ maxWidth: "400px", width: "100%", margin: "0 auto" }} src={require("../content/PB-Sound-logo.png")} />);
}


